export default "__VITE_ASSET__CV4mZpN0__"